export default __webpack_public_path__ + "static/media/delete.611c2576.svg";